import {createSelector} from 'reselect';
import {AppState} from '../..';
import {identity} from '../../../shared/pipes';

export const resourcesSliceSelector = createSelector((state: AppState) => state.resources, identity);

export const contentSelector = () => createSelector(resourcesSliceSelector, (slice) => slice.content.data);
export const faqSelector = () => createSelector(resourcesSliceSelector, (slice) => slice.faq.data);
export const feedbackThemesSelector = createSelector(resourcesSliceSelector, (slice) => slice.feedbackThemes.data);
